<template>
   <div
      id="savings"
      class="position-relative"
      :class="breakpoint">
      <div class="container-fluid container-lg">
         <div class="row font-non-codensed">
            <div class="col-md-5">
               <div
                  class="col-content"
                  :class="breakpoint"
                  :style="{ paddingRight: breakpoint === 'sm' ? '0 !important' : 'initial' }">
                  <div class="left-container">
                     <div
                        class="d-flex text-center text-md-start"
                        :class="{ 'align-items-center justify-content-center': lte('sm') }">
                        <h2>Besparelse i snit</h2>
                     </div>
                     <div class="d-flex align-items-center justify-content-center justify-content-md-start">
                        <div class="amount">
                           {{ saved }}
                        </div>
                        <div class="currency">kr.</div>
                     </div>
                     <div
                        style="font-size: 110%"
                        class="text-center text-md-start">
                        Brugere der har benyttet
                        <br />
                        Findforsikring.dk har gennemsnitligt
                        <br />
                        sparet {{ saved }} kr, og så har de endda
                        <br />
                        også fået bedre dækninger
                     </div>
                  </div>
               </div>
            </div>
            <div class="col-md-7 position-relative">
               <div
                  class="col-content"
                  :class="breakpoint">
                  <div
                     id="savings-product-grid"
                     class="right-container">
                     <hr class="xs-divider d-block d-sm-none" />
                     <div
                        class="d-flex"
                        :class="{ 'align-items-center justify-content-center': lte('sm') }">
                        <h2>Mest efterspurgte forsikringer</h2>
                     </div>
                     <p
                        :class="{ 'text-center': lte('sm') }"
                        style="margin-top: 1em; margin-bottom: 1em">
                        Ønsker du at få forsikringstilbud? Start din forespørgsel herunder ved at vælge nogle af de mest
                        efterspurgte forsikringstyper.
                     </p>
                     <products-grid
                        :limit="5"
                        class="mb-3" />
                     <submit-products-button wrapper="#savings-product-grid" />
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ProductsGrid from './ProductsGrid';
import SubmitProductsButton from './SubmitProductsButton';

export default {
   name: 'MaterialSavingsOld',
   components: { SubmitProductsButton, ProductsGrid },
   computed: {
      ...mapGetters(['stats', 'breakpoint', 'lte']),
      saved() {
         return this.$store.getters.stats.saved;
      },
      single() {
         return this.width <= 910;
      },
      containerClass() {
         return this.lte('sm') ? 'container-fluid' : 'container';
      },
   },
};
</script>

<style lang="scss" scoped>
//noinspection CssUnknownTarget
@import '~/colors.scss';

#savings {
   background-color: $ff-stripe-bg;
   line-height: 1.5 !important;
   color: $ff-dark-blue;
   font-size: 17px;
   &.xs {
      font-size: 13px;
   }
   &.xs,
   &.sm {
      .left-container {
         align-self: center;
      }
   }
   .col-content {
      &.xxl,
      &.xl,
      &.lg,
      &.md {
         padding: 20px 0 !important;
      }
      &.sm,
      &.xs {
         padding: 2em !important;
      }
   }
   padding: 2em 0;
   .left-container {
      max-width: 475px;
      display: flex;
      flex-direction: column;
      > *:not(:first-child) {
         margin-top: 1.5em;
         &:nth-child(2) {
            margin-top: 2.25em;
         }
      }
   }
   .amount {
      //font-family: 'Lato', sans-serif;
      font-size: 500%;
      font-weight: bolder;
      line-height: 1;
      color: $ff-dark-blue;
   }
   .currency {
      line-height: 1;
      //font-family: 'Lato', sans-serif;
      font-weight: bold;
      font-size: 200%;
      margin-left: 5px;
      color: $ff-dark-blue;
   }

   p {
      font-size: unset;
      line-height: 1.5 !important;
   }
}
</style>
